export default "__VITE_ASSET__C4SO8_R0__";